"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkOverflow = checkOverflow;
exports.SKIP_TOP_OVERFLOW_CHECK = exports.SKIP_BOTTOM_OVERFLOW_CHECK = exports.registerOverflowObject = void 0;

var _onResize = require("./onResize");

var objects = [];
var SKIP_BOTTOM_OVERFLOW_CHECK = 'skip-bottom-check';
exports.SKIP_BOTTOM_OVERFLOW_CHECK = SKIP_BOTTOM_OVERFLOW_CHECK;
var SKIP_TOP_OVERFLOW_CHECK = 'skip-top-check';
exports.SKIP_TOP_OVERFLOW_CHECK = SKIP_TOP_OVERFLOW_CHECK;

var checkObject = function checkObject(object) {
  object.component.removeClass('content-overflow');
  var forceContentOverflow = object.forceFn !== undefined ? object.forceFn() : false;
  var rC = object.component.length ? object.component[0].getBoundingClientRect() : {
    top: 0,
    bottom: 0
  };
  var rT = object.target.length ? object.target[0].getBoundingClientRect() : {
    top: 0,
    bottom: 0
  };
  var $bottomCheck = Math.ceil(rT.bottom) > Math.ceil(rC.bottom);
  var $topCheck = Math.floor(rT.top) < Math.floor(rC.top);

  if (object.component.hasClass(SKIP_BOTTOM_OVERFLOW_CHECK)) {
    $bottomCheck = false;
  }

  if (object.component.hasClass(SKIP_TOP_OVERFLOW_CHECK)) {
    $topCheck = false;
  }

  if (forceContentOverflow || $bottomCheck || $topCheck) {
    object.component.addClass('content-overflow');

    if (object.component.width() > object.minWidth) {
      object.minWidth = object.component.width();
    }
  }
};

var registerOverflowObject = function registerOverflowObject($component, $target, forceFn) {
  var object = {
    component: $component,
    target: $target !== undefined ? $target : $component,
    forceFn: forceFn,
    minWidth: 0
  };
  objects.push(object);
  checkObject(object);
};

exports.registerOverflowObject = registerOverflowObject;

function checkOverflow() {
  objects.forEach(function (object) {
    checkObject(object);
  });
}

(0, _onResize.onResize)(checkOverflow);